/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-list-item-pointer',
  templateUrl: 'list-item-pointer.component.html',
  styleUrls: ['list-item-pointer.component.scss'],
})
export class ListItemPointerComponent {
  @Input() dnd: boolean = true;
}
